/* eslint-disable no-param-reassign */
import produce from 'immer';

import {
  DELETE_TABLE_FILTER,
  INC_TABLE_DATA_VERSION,
  REFRESH_TABLE,
  RESET_TABLE_FILTERS,
  RESET_TABLE_SEARCH,
  SET_HEADER_CUSTOMER_NAME,
  SET_ORDER_CREATE_DATE_LIMIT_FILTER,
  SET_TABLE_CHECKED_ITEMS_DATA,
  SET_TABLE_COLUMN_ORDERING,
  SET_TABLE_CONFIG_VIEWS,
  SET_TABLE_CUR_CHECKED_ITEMS_DATA,
  SET_TABLE_CURRENT_PAGE,
  SET_TABLE_FILTERS,
  SET_TABLE_META,
  SET_TABLE_ROWS_PER_PAGE,
  SET_TABLE_SCOPE,
  SET_TABLE_SEARCH,
  SET_WAS_UPDATED,
} from '../constants/actionTypes';

const rowsPerPage = JSON.parse(localStorage.getItem('rowsPerPage')) || '50';

const initialState = {
  scope: null,
  filters: {},
  filterViews: {},
  search: {},
  rowsPerPage,
  currentPage: 1,
  checkedItemsData: [],
  curCheckedItemsData: [],
  customerName: {},
  wasUpdated: false,
  columnOrdering: {},
  orderLimitFilter: null,
  version: {},
};

const TableData = (state = initialState, { type, payload }) => {
  let newFilters = {};
  let newState = {};

  switch (type) {
    case SET_TABLE_SCOPE:
      return produce(state, (draft) => {
        delete draft.totalPages;
        delete draft.totalItems;

        Object.assign(draft, payload);
      });
    case REFRESH_TABLE:
    case RESET_TABLE_SEARCH:
    case SET_TABLE_CHECKED_ITEMS_DATA:
    case SET_TABLE_CUR_CHECKED_ITEMS_DATA:
    case SET_HEADER_CUSTOMER_NAME:
    case SET_TABLE_ROWS_PER_PAGE:
    case SET_TABLE_CURRENT_PAGE:
    case SET_TABLE_META:
      return { ...state, ...payload };
    case INC_TABLE_DATA_VERSION:
      return {
        ...state,
        version: { ...state.version, [payload.scope]: (state.version[payload.scope] || 0) + 1 },
      };
    case SET_TABLE_FILTERS:
      return produce(state, (draft) => {
        const payloadScopes = Object.keys(payload || {});

        payloadScopes.forEach((scope) => {
          draft.search[scope] && delete draft.search[scope];
        });

        Object.assign(draft.filters, payload);
        localStorage.setItem('search', JSON.stringify(draft.search));
        localStorage.setItem('filters', JSON.stringify(draft.filters));
      });
    case SET_ORDER_CREATE_DATE_LIMIT_FILTER:
      return produce(state, (draft) => {
        draft.orderLimitFilter = payload;
      });
    case SET_TABLE_CONFIG_VIEWS:
      return { ...state, configViews: { ...state.configViews, ...payload } };
    case DELETE_TABLE_FILTER:
      newState = produce(state, (draft) => {
        delete draft.filters[payload.scope][payload.filterName];
      });

      localStorage.setItem('filters', JSON.stringify(newState.filters));

      return newState;
    case RESET_TABLE_FILTERS:
      if (payload) {
        newFilters = { ...state.filters };
        delete newFilters[payload];
      }

      localStorage.setItem('filters', JSON.stringify(newFilters));

      return { ...state, filters: newFilters };
    case SET_TABLE_SEARCH:
      return produce(state, (draft) => {
        const payloadScopes = Object.keys(payload || {});

        payloadScopes.forEach((scope) => {
          draft.filters[scope] && delete draft.filters[scope];
        });

        Object.assign(draft.search, payload);
        localStorage.setItem('filters', JSON.stringify(draft.filters));
        localStorage.setItem('search', JSON.stringify(draft.search));
      });
    case SET_WAS_UPDATED:
      return { ...state, wasUpdated: !state.wasUpdated };
    case SET_TABLE_COLUMN_ORDERING:
      return produce(state, (draft) => {
        draft.columnOrdering[payload.scope] = payload.columnOrdering;
      });
    default:
      return state;
  }
};

export default TableData;
